import { Stack, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import { useGetSubscriptionsQuery } from "src/api/services/patientSubscriptionApi";
import Loading from "src/components/Loading/Loading";
import SubscriptionCard from "../SubscriptionCard";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "src/hooks/useIsMobile";
import ReactivationModal from "src/shared/components/ReactivationModal";

const InactiveSubscriptions = () => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const page = "subscriptions";
  const { subscriptions, isLoading } = useGetSubscriptionsQuery(undefined, {
    selectFromResult: (result) => {
      const canceled =
        result.data?.filter(
          (sub) =>
            sub.status === "canceled" &&
            sub.product.billing_model !== "one_time"
        ) ?? [];
      return { subscriptions: canceled, isLoading: result.isLoading };
    },
  });
  const [open, setOpen] = useState<boolean>(false);
  const [selectedSub, setSelectedSub] = useState<number | undefined>();

  const handleReactivateModal = useCallback((subId: number) => {
    setOpen(true);
    setSelectedSub(subId);
  }, []);

  const handleCloseModal = useCallback(() => {
    setOpen((o) => !o);
    setSelectedSub(undefined);
  }, []);

  if (subscriptions.length === 0) {
    return null;
  }

  return (
    <Stack gap={isMobile ? 1 : 2}>
      <Typography variant="h6" fontWeight={700}>
        {t(`${page}.subheader.inactive`, "Inactive")}
      </Typography>
      {isLoading ? (
        <Loading />
      ) : (
        subscriptions.map((sub) => (
          <SubscriptionCard
            key={sub.id}
            subscription={sub}
            handleReactivation={handleReactivateModal}
          />
        ))
      )}
      <ReactivationModal
        open={open}
        onClose={handleCloseModal}
        subscriptionId={selectedSub}
      />
    </Stack>
  );
};

export default InactiveSubscriptions;
